const data = [
  {
    name: "Knoll",
    description: "#a8edea → #fed6e3",
    css: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
    height: 200,
    imageUrl: "/assets/images/marques/knoll-removebg-preview.png",
    link: "https://www.knoll.com/"
  },
  {
    name: "Vitra",
    description: "#f5f7fa → #c3cfe2",
    css: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/vitra-removebg-preview.png",
    link: "https://www.vitra.com/fr-fr/home"
  },
  {
    name: "Ethimo",
    description: "#e0c3fc → #8ec5fc",
    css: "linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/ethimo-removebg-preview.png",
    link: "https://www.ethimo.com/fr/"
  },
  {
    name: "Living Divani",
    description: "#f093fb → #f5576c",
    css: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/living-divani-removebg-preview.png",
    link: "https://livingdivani.it/"
  },
  {
    name: "USM",
    description: "#fdfbfb → #ebedee",
    css: "linear-gradient(135deg, #E3FDF5 0%, #FFE6FA 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/usm-removebg-preview.png",
    link: "https://www.usm.com/fr-fr/"
  },
  {
    name: "De Castelli",
    description: "#5ee7df → #b490ca",
    css: "linear-gradient(135deg, #5ee7df 0%, #b490ca 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/de-castelli-removebg-preview.png",
    link: "https://www.decastelli.com/fr/"
  },
  {
    name: "MDF Italia",
    description: "#d299c2 → #fef9d7",
    css: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)",
    height: 200,
    imageUrl: "/assets/images/marques/mdf-italia-removebg-preview.png",
    link: "https://www.mdfitalia.com/fr/"
  },
  {
    name: "Kristalia",
    description: "#ebc0fd → #d9ded8",
    css: "linear-gradient(135deg, #ebc0fd 0%, #d9ded8 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/kristalia-removebg-preview.png",
    link: "https://www.kristalia.it/fr/"
  },
  {
    name: "FLOS",
    description: "#f6d365 → #fda085",
    css: "linear-gradient(135deg, #f6d365 0%, #fda085 100%)",
    height: 200,
    imageUrl: "/assets/images/marques/flos-removebg-preview.png",
    link: "https://flos.com/"
  },
  {
    name: "Vibia",
    description: "#96fbc4 → #f9f586",
    css: "linear-gradient(135deg, #96fbc4 0%, #f9f586 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/vibia-removebg-preview.png",
    link: "https://www.vibia.com/fr/"
  },
  {
    name: "Bocci",
    description: " #FFFEFF → #D7FFFE",
    css: "linear-gradient(135deg, #FFFEFF 0%, #D7FFFE 100%)",
    height: 200,
    imageUrl: "/assets/images/marques/bocci-removebg-preview.png",
    link: "https://bocci.com/"
  },
  {
    name: "Manutti",
    description: " #fff1eb → #ace0f9",
    css: "linear-gradient(135deg, #fff1eb 0%, #ace0f9 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/manutti-removebg-preview.png",
    link: "https://www.manutti.com/fr/"
  },
  {
    name: "Muuto",
    description: " #c1dfc4 → #deecdd",
    css: "linear-gradient(135deg, #c1dfc4 0%, #deecdd 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/muuto-removebg-preview.png",
    link: "https://muuto.com/fr/"
  },
  {
    name: "David Groppi",
    description: " #ddd6f3 → #faaca8",
    css: "linear-gradient(135deg, #ddd6f3 0%, #faaca8 100%, #faaca8 100%)",
    height: 200,
    imageUrl: "/assets/images/marques/david-groppi-removebg-preview.png",
    link: "https://www.davidegroppi.com/"
  },
  {
    name: "Zanotta",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/zanotta-removebg-preview.png",
    link: "https://www.zanotta.it/fr/"
  },
  {
    name: "Tribù",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 200,
    imageUrl: "/assets/images/marques/tribu-removebg-preview.png",
    link: "https://www.tribu.com/fr/"
  },
  {
    name: "ClassiCon",
    description: " #ffecd2 → #fcb69f",
    css: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
    height: 200,
    imageUrl: "/assets/images/marques/classicon-removebg-preview.png",
    link: "https://www.classicon.com/fr/"
  },
  {
    name: "Lema",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/lema-removebg-preview.png",
    link: "https://www.lemamobili.com/fr/"
  },
  {
    name: "Treku",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/treku-removebg-preview.png",
    link: "https://www.treku.com/"
  },
  {
    name: "Domani",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/domani-removebg-preview.png",
    link: "https://www.domani.be/fr/"
  },
  {
    name: "Tecno",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/tecno-removebg-preview.png",
    link: "https://www.tecnospa.com/"
  },
  {
    name: "Arper",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/arper-removebg-preview.png",
    link: "https://www.arper.com/fr/"
  },
  {
    name: "Gandia Blasco",
    description: " #f9d423 → #ff4e50",
    css: "linear-gradient(135deg, #f9d423 0%, #ff4e50 100%)",
    height: 400,
    imageUrl: "/assets/images/marques/gandia-blasco-removebg-preview.png",
    link: "https://www.gandiablasco.com/fr/"
  }
];

export default data;